/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the SQL query execution
*/
export enum SqlQueryExecutionStatus {
  SQL_QUERY_EXECUTION_STATUS_QUEUED = 'QUEUED',
  SQL_QUERY_EXECUTION_STATUS_RUNNING = 'RUNNING',
  SQL_QUERY_EXECUTION_STATUS_SUCCEEDED = 'SUCCEEDED',
  SQL_QUERY_EXECUTION_STATUS_FAILED = 'FAILED',
  SQL_QUERY_EXECUTION_STATUS_CANCELLED = 'CANCELLED'
}
